<template>
  <div :class="$style.avatar">
    <span :class="$style.initials">{{ userInitials }}</span>
  </div>
</template>

<script>
/* eslint-disable vue/require-default-prop */

import Util from 'client/util/Util';

const { initials } = Util;

export default {
  name: 'Avatar',
  props: {
    email: {
      type: String,
    },
    firstName: {
      type: String,
    },
    lastName: {
      type: String,
    },
  },
  computed: {
    userInitials() {
      const { email, firstName, lastName } = this;
      const string1 = firstName || email || 'U';
      const string2 = lastName;

      return initials(string1, string2);
    },
  },
};
</script>

<style module>
.avatar {
  background: var(--jcPrimary);
  border-radius: 1em;
  color: var(--jcGrey900);
  display: inline-flex;
  font-weight: 300;
  height: 1em;
  text-transform: uppercase;
  width: 1em;
}

.initials {
  font-size: 0.5em;
  margin: auto;
}
</style>
